export default "__VITE_ASSET__d7eeed77__"